import React from "react";

// Shimmer placeholder shown while a report/chart is loading, in place of a
// blank panel with only a small antd Spin icon over empty space.
const SkeletonBlock = ({ className = "", style }) => (
  <div className={`edr-skeleton ${className}`} style={style} />
);

export default SkeletonBlock;
